import { makeStyles } from '@material-ui/core/styles';

import { blue } from 'shared/styles/colors';

export default makeStyles({
  restList: {
    '& > [aria-label="quantity"]': {
      color: blue['60'],
      fontStyle: 'italic',
      '& ~ small': {
        display: 'none',
      },
      '&:hover ~ small': {
        display: 'inline-block',
        fontSize: '0.75rem',
      },
    },
  },
});
